import { ConfigType } from "@stitches/react/types/config";

const media: ConfigType.Media = {
  bp1: "(min-width: 600px)",
  bp2: "(min-width: 1000px)",
  bp3: "(min-width: 1080px)",
};

export default media;
